import { SharedModule } from '../../../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { SpinnerModule } from 'src/app/shared/spinner/spinner.module';
import { LoginDialogComponent } from './login-dialog.component';
import { LoginGoogleModule } from 'src/app/shared/login-google/login-google.module';
import { LoginDiologRoutingModule } from './login-dialog-routing.module';


@NgModule({
  declarations: [
    LoginDialogComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    SpinnerModule,
    LoginDiologRoutingModule,
    LoginGoogleModule,
  ],
  exports: [
    LoginDialogComponent
  ]
})
export class LoginDiologModule { }
